import React, { useState, useEffect } from "react";

const Menu = ({ items = [] }) => {
  const [open, setOpen] = useState(false);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <>
      {/* Hamburger (mobile only) */}
      <button
        aria-label={open ? "Close menu" : "Open menu"}
        aria-expanded={open}
        aria-controls="mobile-menu"
        className="fixed top-4 right-4 z-50 flex flex-col justify-between w-8 h-6 focus:outline-none md:hidden"
        onClick={() => setOpen((v) => !v)}
      >
        <span
          className={`h-[3px] w-full bg-black transition-all duration-300 ${
            open ? "rotate-45 translate-y-[9px]" : ""
          }`}
        />
        <span
          className={`h-[3px] w-full bg-black transition-all duration-300 ${
            open ? "opacity-0" : ""
          }`}
        />
        <span
          className={`h-[3px] w-full bg-black transition-all duration-300 ${
            open ? "-rotate-45 -translate-y-[9px]" : ""
          }`}
        />
      </button>

      {/* Fullscreen Overlay (white bg, black text) */}
      <div
        id="mobile-menu"
        className={`fixed inset-0 z-40 flex flex-col items-center justify-center bg-white transition-transform duration-500 md:hidden ${
          open ? "translate-x-0" : "translate-x-full"
        }`}
        role="dialog"
        aria-modal="true"
      >
        {items.map((item, idx) => (
          <a
            key={idx}
            href={item.href || "#"}
            className="text-black text-3xl font-bold mb-6 hover:opacity-60 transition-opacity"
            onClick={() => setOpen(false)}
          >
            {item.label}
          </a>
        ))}
      </div>
    </>
  );
};

export default Menu;

